module.exports = __webpack_public_path__ + "static/media/Online_offline.89426092.png";